<template>
  <div class="custom__table">
    <!-- 批量删除 -->
    <div v-if="checkbox || batchDelete" class="custom__table__delete--batch">
      <batch-delete
        v-if="multipleSelection.length"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :show-total="checkbox"
        :show-all-current="showAllCurrent || batchDelete"
        :show-all-total="false"
        :show-batch-delete="batchDelete"
        :current-select-num="multipleSelection.length"
        @resetData="resetData"
        @currentPageall="currentPageall"
        @deleteData="deleteData"
      >
        <div slot="batchL">
          <slot name="batchDeleteBatchL"></slot>
        </div>
      </batch-delete>
    </div>
    <!-- /批量删除 -->

    <!-- 表格 -->
    <div class="edm_table--content">
      <div class="table-warp">
        <!-- <el-table
          class="self-table"
          v-skeleton="skeletonParams"
          :data="showData"
          stripe
          ref="multipleTable"
          row-key="id"
          @selection-change="handleSelectionChange"
          @header-dragend="handleHeaderDragend"
        >
          <el-table-column fixed v-if="checkbox || batchDelete" type="selection" width="55" reserve-selection="true"></el-table-column>
          <el-table-column
            fixed
            v-if="order"
            type="index"
            :label="$t('public.index')"
            width="80"
            :index="table_index"
          ></el-table-column>
          <slot></slot>
        </el-table> -->
        <el-table
          ref="multipleTable"
          v-skeleton="skeletonParams"
          class="self-table"
          stripe
          border
          v-bind="$attrs"
          :data="showData"
          :row-key="rowKey"
          :height="height"
          v-on="$listeners"
          @select="handleCheckChange"
          @select-all="handleAllCheckChange"
          @header-dragend="handleHeaderDragend"
          @row-click="tableRow"
        >
          <el-table-column
            v-if="checkbox || batchDelete"
            fixed
            type="selection"
            width="60"
            :reserve-selection="reserveSelection"
          ></el-table-column>
          <el-table-column
            v-if="order"
            fixed
            type="index"
            :label="$t('public.index')"
            width="80"
            :index="table_index"
          ></el-table-column>
          <slot></slot>
        </el-table>
      </div>

      <!-- 表格分页 -->
      <pagination
        v-show="showPagination && tableData && tableData.length"
        :page-info="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <!-- /表格分页 -->
      <!-- 表格空状态 -->
      <empty v-show="showEmpty && (!tableData || !tableData.length) && !skeletonParams.loading" />
      <!-- /表格空状态 -->
    </div>
    <!-- /表格 -->
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination";
import BatchDelete from "@/components/common/batch-delete";
import Empty from "@/components/private/empty";

export default {
  name: "EdmCustomTable",
  components: {
    Pagination,
    BatchDelete,
    Empty
  },
  props: {
    showPagination: {
      type: Boolean,
      default: true
    },
    rowKey: {
      type: String,
      default: "id"
    },
    reserveSelection: {
      type: Boolean,
      default: false
    },
    frontPagination: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    batchDelete: {
      type: Boolean,
      default: false
    },
    checkbox: {
      type: Boolean,
      default: false
    },
    order: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Object,
      default: () => ({
        pageNum: 1,
        pageSize: 10,
        total: 0
      })
    },
    tableData: {
      type: Array,
      default: () => []
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    },
    height: {
      type: [Number, String],
      default: null
    },
    showEmpty: {
      type: Boolean,
      default: true
    },
    showAllCurrent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      multipleSelection: [],
      showData: []
    };
  },
  computed: {
    skeletonParams() {
      return {
        loading: this.loading
      };
    }
  },
  watch: {
    defaultCheckedKeys: {
      handler(val, oldVal) {
        this.multipleSelection = JSON.parse(JSON.stringify(val || []));
      },
      immediate: true
    },
    tableData: {
      handler(val) {
        let value = val;
        if (this.showPagination) {
          if (this.frontPagination) {
            const start = (this.pagination.pageNum - 1) * this.pagination.pageSize;
            const end = this.pagination.pageNum * this.pagination.pageSize;
            value = val.filter((o, index) => index >= start && index < end);
          }
        }
        this.$set(this, "showData", value);
        console.log(value);
        this.updateCheckedStatus();
        this.$nextTick(() => this.$refs.multipleTable.doLayout());
      },
      deep: true,
      immediate: true
    },
    reserveSelection(newVal, oldVal) {
      if (!newVal) {
        this.multipleSelection = [];
      }
    },
    // 监测骨架屏结束后，动态doLayout
    skeletonParams: {
      deep: true,
      handler() {
        this.$nextTick(() => this.$refs.multipleTable.doLayout());
      }
    }
  },
  created() {
    let value = this.tableData;
    if (value.length) {
      if (this.showPagination) {
        if (this.frontPagination) {
          const start = (this.pagination.pageNum - 1) * this.pagination.pageSize;
          const end = this.pagination.pageNum * this.pagination.pageSize;
          value = this.tableData.filter((o, index) => index >= start && index < end);
        }
      }
      this.$set(this, "showData", value);
      this.updateCheckedStatus();
    }
  },
  mounted() {},
  methods: {
    refreshTable(val) {
      let value = val;
      if (this.showPagination) {
        if (this.frontPagination) {
          const start = (this.pagination.pageNum - 1) * this.pagination.pageSize;
          const end = this.pagination.pageNum * this.pagination.pageSize;
          value = val.filter((o, index) => index >= start && index < end);
        }
      }
      this.$set(this, "showData", value);
      this.updateCheckedStatus();
      this.$nextTick(() => this.$refs.multipleTable.doLayout());
    },
    updateCheckedStatus() {
      // 当table使用selection-change, 此处回显会引起selection-change事件的循环调用
      if (Array.isArray(this.multipleSelection) && this.checkbox && this.reserveSelection) {
        this.setCheckedStatus();
      } else {
        this.multipleSelection = [];
      }
    },
    setCheckedStatus(defaultVal) {
      this.showData.forEach(it => {
        let pass = false;
        if (this.multipleSelection.some(o => o[this.rowKey] === it[this.rowKey])) {
          pass = true;
        }
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(it, pass); // 回显
        });
      });
    },
    // 序号
    table_index(index) {
      if (this.pagination && Object.keys(this.pagination).length !== 0) {
        return (this.pagination.pageNum - 1) * this.pagination.pageSize + index + 1;
      } else {
        return index + 1;
      }
    },
    // 拖拽
    handleHeaderDragend(newWidth, oldWidth, column, event) {
      this.$emit("handleHeaderDragend", newWidth, oldWidth, column, event);
    },
    // 复选框
    handleAllCheckChange(selection) {
      this.updateMultipleSelection(selection);
    },
    // 复选框
    handleCheckChange(selection) {
      this.updateMultipleSelection(selection);
    },
    // 更新MultipleSelection
    updateMultipleSelection(selection) {
      this.showData.forEach(o => {
        const isAdd = selection.some(t => t[this.rowKey] === o[this.rowKey]);
        if (isAdd) {
          if (!this.multipleSelection.some(t => t[this.rowKey] === o[this.rowKey])) {
            this.multipleSelection.push(o);
          }
        } else {
          const index = this.multipleSelection.findIndex(t => t[this.rowKey] === o[this.rowKey]);
          if (index >= 0) {
            this.multipleSelection.splice(index, 1);
            this.$refs.multipleTable.toggleRowSelection(o, false);
          }
        }
      });
      this.$emit("checkedTable", this.multipleSelection);
    },
    // handleSelectionChange(val) {
    //   if (this.checkbox || this.batchDelete) {
    //     this.multipleSelection = val;
    //   }
    // },
    // 条数改变
    handleSizeChange(data) {
      this.updateShowData(data);
      this.$emit("handleSizeChange", data);
    },
    // 页数改变
    handleCurrentChange(data) {
      this.$refs.multipleTable.$el.querySelector(".el-table__body-wrapper").scrollTop = 0;
      this.updateShowData(data);
      this.$emit("handleCurrentChange", data);
    },
    updateShowData(data) {
      if (this.frontPagination) {
        const { pageNum, pageSize } = data;
        const start = (pageNum - 1) * pageSize;
        const end = pageNum * pageSize;
        this.$set(
          this,
          "showData",
          this.tableData.filter((o, index) => index >= start && index < end)
        );
      }
    },
    // 批量删除
    deleteData() {
      if (this.batchDelete) {
        this.$emit("batchDeleteData", this.multipleSelection);
      }
    },
    // 全选当前页
    currentPageall() {
      if (this.multipleSelection.length === this.tableData.length) {
        return;
      }
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 清空
    resetData() {
      this.multipleSelection = [];
      this.$refs.multipleTable.clearSelection();
      this.$emit("checkedTable", []);
    },
    // 获取选中项
    getChecked() {
      return this.multipleSelection;
    },
    setCheckeds(row) {
      if (row) {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    // 清空取选中项
    resetChecked() {
      this.multipleSelection = [];
    },
    tableRow(val) {
      if (this.checkbox) {
        // this.$refs.multipleTable.toggleRowSelection(val, true);
      } else {
        this.$emit("tableRowClick", val);
      }
    },
    doLayout() {
      this.$refs.multipleTable.doLayout();
    }
  }
};
</script>

<style lang="scss" scoped>
.custom__table {
  width: 100%;
  .edm_table--content {
    ::v-deep .el-table {
      th:hover {
        border-right: 1px solid #d4d9e2;
      }
    }
  }
  .edm_table--content {
    width: 100%;
    display: block;
  }
}
</style>
